<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
						<a href="#">{{ $t("HomeMenu") }}</a>
					</router-link>
					<router-link :to="{ name: 'Gacha' }" tag="li" class="breadcrumb-item">
						<a href="#">{{ $t("GachaMenu") }}</a>
					</router-link>
				</ol>
			</nav>
			<div class="kokoro">
				<div class="speech-bubble">
					<span>
						{{ kokoro }}
					</span>
					<br />
					<img class="upChance" src="static/images/222.jpg" v-if="percent == 5" />
				</div>
				<img src="static/images/kokoro.png" />
			</div>
			<div class="item-box py-3 my-4 gacha-function-bar clearfix">
				<div class="gacha-box mb-3">
					<div class="d-flex flex-wrap gacha-content justify-content-center">
						<div v-for="item in price" class="gacha-item" :class="checkStar(item.rarity)">
							<img v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'" alt="" />
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 mb-3 gacha-info-box">
						<div class="gacha-info mr-3">
							次數 <span class="g-font">{{ time }}</span>
						</div>
						<div class="gacha-info mr-3">
							寶石: <span class="g-font">{{ money }}</span>
						</div>
						<div class="gacha-info mr-3">
							消費: <span class="g-font">{{ 750 * time }}</span> NTD
						</div>
						<div class="gacha-info mr-3">
							女神的秘石: <span class="g-font">{{ megamiStone }}</span>
						</div>
						<div class="gacha-info mr-3">
							★3機率: <span class="g-font">{{ star3per }}%</span>
						</div>
						<div class="gacha-info select">
							<label class="mr-1">★3出現機率: </label>
							<select class="form-control selectOp d-inline-block" v-model="percent">
								<option value="6.5">6% 加倍</option>
								<option value="6">6%</option>
								<option value="5">5%</option>
								<option value="3">3%</option>
								<option value="2.5">2.5%</option>
							</select>
						</div>
					</div>
					<div class="col-12 gacha-function-button">
						<button type="button" @click="clear" class="pcbtn danger px-3 mx-3">{{ $t("Reset") }}</button>
						<button type="button" @click="lottory" class="pcbtn primary px-3 mx-3">{{ $t("10Gacha") }}</button>
					</div>
				</div>
			</div>
			<div class="d-flex item-box flex-wrap py-4 gacha-get-box" style="min-height: 136px"
				v-if="gacha3StarList.length > 0">
				<div v-for="item in gacha3StarList" class="p-2">
					<router-link :to="{ name: 'CharacterDetail', params: { id: item.unit_name } }" target="_blank">
						<img class="img-fluid"
							v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'"
							:alt="item.unit_name" :title="item.unit_name" />
					</router-link>
				</div>
			</div>
			<div class="my-3" style="max-height: 100px" v-if="clientWidth <= 1800">
				<ins class="adsbygoogle my-3" style="display:block" data-ad-client="ca-pub-8839550417970110"
					data-ad-slot="5517770705" data-ad-format="auto" data-full-width-responsive="true"></ins>
			</div>
			<div class="item-box gacha-list-box my-3">
				<div class="d-block">
					<img src="/static/images/star.png" width="30" />
					<img src="/static/images/star.png" width="30" />
					<img src="/static/images/star.png" width="30" />
				</div>
				<div class="d-block mb-3">
					{{ $t("AdjustPool") }}
				</div>
				<div class="d-flex flex-wrap py-3">
					<div class="p-1 gacha-list-item" v-for="(item, index) in getStar3List" :value="item.unit_id"
						:key="item.unit_id" :class="item.active ? 'active' : ''">
						<div class="card-deck">
							<div class="card" :style="[item.count >= '1' ? { background: 'pink' } : '']">
								<div @click="addUp(item, index)" class="cursor-pointer text-center mb-1"
									v-on:click="$forceUpdate()">
									<span v-if="item.up" class="badge badge-danger">UP</span>
									<span v-else class="badge badge-light">UP</span>
								</div>
								<div @click="addInLottory(item, index)" class="cursor-pointer text-center">
									<div v-if="item.active">
										<img width="70"
											v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'"
											:alt="item.unit_name" :title="item.unit_name" />
									</div>
									<div v-else class="gacha-plus-box">
										<img class="grayimg mx-auto" width="70"
											v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'"
											:alt="item.unit_name" :title="item.unit_name" />
									</div>
								</div>
								<div class="text-center">
									<span v-html="getGachaType(item.unit_id)"></span>
								</div>
								<div class="text-center">
									<small class="text-muted"> {{ item.odd }} % </small>
								</div>
								<div class="card-footer text-center">
									<small class="text-muted">{{ item.count }}</small>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="d-block">
					<img src="/static/images/star.png" width="30" />
					<img src="/static/images/star.png" width="30" />
				</div>
				<div class="d-flex flex-wrap py-3">
					<div class="p-1" v-for="item in star2">
						<div class="card-deck">
							<div class="card" style="width: 80px">
								<img width="80"
									v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 10) + '.png'"
									:alt="item.unit_name" :title="item.unit_name" />
								<div class="card-footer text-center">
									<small class="text-muted">{{ item.count }}</small>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="d-block">
					<img src="/static/images/star.png" width="30" />
				</div>
				<div class="d-flex flex-wrap py-3">
					<div class="p-1" v-for="item in star1">
						<div class="card-deck">
							<div class="card" style="width: 80px">
								<img width="80"
									v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 10) + '.png'"
									:alt="item.unit_name" :title="item.unit_name" />
								<div class="card-footer text-center">
									<small class="text-muted">{{ item.count }}</small>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import GachaPool from "../assets/edata/gacha_pool.json";
export default {
	name: "Gacha",
	metaInfo: {
		title: "抽卡轉蛋模擬器",
		// all titles will be injected into this template
		titleTemplate: "%s | 蘭德索爾圖書館 公主連結 Wiki",
		meta: [
			{ charset: "utf-8" },
			{
				name: "description",
				content: "超異域公主連結☆Re:Dive (公主連結R) 的抽卡(轉蛋)模擬器，模擬當期出現率增加的角色在10連抽出現的機率，試試看自己現在的運氣吧！",
			},
		],
	},
	data() {
		return {
			openHistory3star: true,
			percent: "3",
			price: {},
			histroy: [],
			units: {},
			units3: {},
			star3: [],
			star2: [],
			star1: [],
			gacha3StarList: [],
			money: 0,
			time: 0,
			get3: 0,
			star3per: 0,
			upList: ["129801"],
			kokoro: "我會為主人加油的",
			chara_identity: {},
			megamiStone: 0,
			gachaPool: GachaPool,
		};
	},
	props: ["clientWidth"],
	created: function () {
		var self = this;
		var star3 = _.filter(self.$store.getters.getUnitData, function (o) {
			return o.rarity == 3;
		});
		//active 112201
		var notActive = [
			"106101", "107101", "108101", "107501", "107001", "107701", "125301",
			"107801", "107901", "108301", "108801", "108701", "109101", "127201",
			"108301", "109701", "109901", "110301", "110601", "110001", "110401",
			"111101", "170201", "112001", "111901", "106401", "108401", "108601",
			"112401", "113101", "180501", "180601", "180301", "180401", "113401",
			"106801", "180701", "112501", "115001", "120901", "180201", "114401",
			"180101", "111801", "113901", "117001", "115501", "119901", "121001",
			"117201", "118101", "120701", "118001", "117701", "106701", "180801",
			"123301", "121101", "121501", "111501", "123001", "180901", "122501",
			"123601", "122901", "106901", "120001", "124001", "124601", "181001",
			"124301", "124401", "124501", "124801", "125001", "", "126001",
			"126401", "126601", "123801", "127101", "126501", "125501", "128701",
			"126101", "126901", "130901", "125601", "126201", "130701", "128501",
			"129901", "181101", "118201", "127501", "129001", "129301", "131601",
			"127901", "129601", "131001", "130801", "128401", "128901", "129701",
			"131201", "131101", "131701"
		];
		var star3List = new Array();
		star3 = _.forEach(star3, function (value) {
			_.forEach(self.$store.getters.getCharaIdentity, function (o) {
				if (o.unit_id == value.unit_id) {
					o["rarity"] = value.rarity;
					if (_.includes(notActive, o.unit_id)) {
						o["active"] = false;
					} else {
						o["active"] = true;
					}
					if (_.includes(self.upList, o.unit_id)) {
						o["up"] = true;
					} else {
						o["up"] = false;
					}
					o["count"] = 0;
					o.unit_name = value.unit_name;
					star3List.push(o);
				}
			});
		});
		self.star3 = star3List;
		///// star2
		var star2 = _.filter(self.$store.getters.getUnitData, function (o) {
			return o.rarity == 2;
		});
		var star2List = new Array();
		star2 = _.forEach(star2, function (value) {
			_.forEach(self.$store.getters.getCharaIdentity, function (o) {
				if (o.unit_id == value.unit_id) {
					o["rarity"] = value.rarity;
					o["count"] = 0;
					o.unit_name = value.unit_name;
					star2List.push(o);
				}
			});
		});
		self.star2 = star2List;
		///// star1
		var star1 = _.filter(self.$store.getters.getUnitData, function (o) {
			return o.rarity == 1;
		});
		var star1List = new Array();
		star1 = _.forEach(star1, function (value) {
			_.forEach(self.$store.getters.getCharaIdentity, function (o) {
				if (o.unit_id == value.unit_id) {
					o["rarity"] = value.rarity;
					o["count"] = 0;
					o.unit_name = value.unit_name;
					star1List.push(o);
				}
			});
		});
		var notActiveS1 = [
			"100201", "106001", "105801", "105901", "107601", "108001", "108201",
			"108501", "108901", "109001", "109301", "109801", "110101", "110501",
			"111201", "111601", "112101", "112301", "112601", "113001", "113201",
			"113501", "114101", "114601", "114701", "115601", "115801", "116801",
			"117401", "117801", "118501", "119201", "120801", "121201", "122101",
			"122401", "122801", "123501", "124101", "124701", "124901", "125701",
			"126701", "127001", "128301", "128801"
		];
		star1List = _.filter(star1List, function (o) {
			return !_.includes(notActiveS1, o.unit_id);
		});
		//101301
		self.star1 = star1List;
	},
	methods: {
		lottory: function (e, itemId) {
			e.preventDefault();
			var self = this;
			var nowPercent = Number(self.percent);
			if (nowPercent > 6.5) {
				self.kokoro = "(((ﾟДﾟ;)))";
				return;
			}
			var isUpUp = false;
			if (nowPercent == "6.5") {
				isUpUp = true;
				nowPercent == 6;
			}
			var arr = new Array();
			var gacha3 = self.gacha3StarList;
			var nowActiveListS3 = _.filter(self.star3, function (o) {
				return o.active == true;
			});
			var hasUp = _.find(nowActiveListS3, ["up", true]);
			var hasUpPercent = 70;
			if (isUpUp) {
				hasUpPercent = 140;
			}
			var onetimestar3 = 0;
			var i;
			if (self.time == 0) {
				self.time == 1;
			}
			for (i = 0; i < 10; i++) {
				var random = _.random(0, 10000, true);
				var gachaList = new Array();
				if (i <= 8) {
					if (random < 100 * nowPercent) {
						var unit = {};
						if (hasUp) {
							var star3up = _.random(0, 100 * nowPercent, true);
							if (star3up <= hasUpPercent) {
								unit = _.sample(
									_.filter(nowActiveListS3, function (o) {
										return o.up == true;
									})
								);
							} else {
								unit = _.sample(
									_.filter(nowActiveListS3, function (o) {
										return o.up != true;
									})
								);
							}
						} else {
							unit = _.sample(nowActiveListS3);
						}
						gacha3.push(unit);
						self.gacha3StarList = gacha3;
						_.forEach(self.star3, function (o) {
							if (o.unit_id == unit.unit_id) {
								var count = o["count"] + 1;
								self.megamiStone = self.megamiStone + 50;
								o["count"] = count;
							}
						});
						onetimestar3 = onetimestar3 + 1;
						arr.push(unit);
					} else if (random > 200 && random < 1800) {
						var unit = _.sample(self.star2);
						_.forEach(self.star2, function (o) {
							if (o.unit_id == unit.unit_id) {
								var count = o["count"] + 1;
								o["count"] = count;
								self.megamiStone = self.megamiStone + 10;
							}
						});
						arr.push(unit);
					} else {
						var unit = _.sample(self.star1);
						_.forEach(self.star1, function (o) {
							if (o.unit_id == unit.unit_id) {
								var count = o["count"] + 1;
								o["count"] = count;
								self.megamiStone = self.megamiStone + 1;
							}
						});
						arr.push(unit);
					}
				} else {
					if (random < 100 * nowPercent) {
						var unit = {};
						if (hasUp) {
							var star3up = _.random(0, 100 * nowPercent, true);
							if (star3up <= hasUpPercent) {
								unit = _.sample(
									_.filter(nowActiveListS3, function (o) {
										return o.up == true;
									})
								);
							} else {
								unit = _.sample(
									_.filter(nowActiveListS3, function (o) {
										return o.up != true;
									})
								);
							}
						} else {
							unit = _.sample(nowActiveListS3);
						}
						gacha3.push(unit);
						self.gacha3StarList = gacha3;
						_.forEach(self.star3, function (o) {
							if (o.unit_id == unit.unit_id) {
								var count = o["count"] + 1;
								o["count"] = count;
								self.megamiStone = self.megamiStone + 50;
							}
						});
						onetimestar3 = onetimestar3 + 1;
						arr.push(unit);
					} else {
						var unit = _.sample(self.star2);
						_.forEach(self.star2, function (o) {
							if (o.unit_id == unit.unit_id) {
								var count = o["count"] + 1;
								o["count"] = count;
								self.megamiStone = self.megamiStone + 10;
							}
						});
						arr.push(unit);
					}
				}
			}
			var histroy = self.histroy;
			histroy.push(arr);
			self.price = arr;
			self.histroy = histroy;
			self.money = self.money + 1500;
			self.time = self.time + 1;
			var getAll = _.filter(nowActiveListS3, function (o) {
				return o.count == "0";
			});
			if (self.time >= 30 && self.gacha3StarList.length <= 6) {
				self.kokoro = "主人難道你是非洲來的嗎？";
			} else if (self.time * 750 >= 18000 && self.gacha3StarList.length <= 3) {
				self.kokoro = "主人我建議你去買禮包吧。";
			} else if (self.time >= 20 && self.gacha3StarList.length <= 4) {
				self.kokoro = "主人你這麼黑，還是不要抽了吧。";
			} else if (self.time >= 10 && self.gacha3StarList.length <= 1) {
				self.kokoro = "主人一定只是運氣不好而已。";
			} else if (onetimestar3 >= 2) {
				self.kokoro = "主人真是幸運呢。 一次找來" + onetimestar3 + "個夥伴。";
			} else if (self.time * 750 >= 100000) {
				self.kokoro = "感謝課長大大讓我們有遊戲玩。";
			} else if (self.time * 750 >= 50000) {
				self.kokoro = "公主發大財。";
			} else if (self.time * 750 >= 35000) {
				self.kokoro = "主人再抽下去就要露宿街頭了。";
			} else if (self.time * 750 >= 20000) {
				self.kokoro = "主人的荷包...應該還可以吧。";
			} else if (self.time * 750 >= 10000) {
				self.kokoro = "一切都是為了新的夥伴！";
			}
			var star3per = (self.gacha3StarList.length / (self.time * 10)) * 100;
			star3per = star3per.toFixed(4);
			self.star3per = star3per;
			if (_.isEmpty(getAll) || _.isNull(getAll)) {
				self.isGetAll = true;
				var star3per = (self.gacha3StarList.length / (self.time * 10)) * 100;
				star3per = star3per.toFixed(4);
				self.kokoro = "主人已經找齊全部的伙伴了呢。 ★3機率為" + star3per + "%";
			}
		},
		clear: function () {
			var self = this;
			self.price = {};
			self.histroy = [];
			self.money = 0;
			self.time = 0;
			self.megamiStone = 0;
			self.gacha3StarList = [];
			self.star3per = 0;
			self.kokoro = "我會為主人加油的";
			self.isGetAll = false;
			_.forEach(self.star3, function (o) {
				o["count"] = 0;
			});
			_.forEach(self.star2, function (o) {
				o["count"] = 0;
			});
			_.forEach(self.star1, function (o) {
				o["count"] = 0;
			});
		},
		getGachaType: function (unit_id) {
			var self = this;
			var gachaType = _.findKey(self.gachaPool, function (item) {
				return item.indexOf(unit_id) !== -1;
			});
			var name = "";
			var color = "secondary";
			switch (gachaType) {
				case "always":
					name = "常駐池";
					color = "primary";
					break;
				case "season":
					name = "季節限定";
					color = "danger";
					break;
				case "limited":
					name = "期間限定";
					color = "success";
					break;
				case "fes":
					name = "公主祭典";
					color = "warning";
					break;
				case "extra":
					name = "額外兌換";
					color = "";
					break;
				default:
					name = "尚未設定";
					break;
					return;
			}
			return `<span class='badge badge-${color}'>${name}</span>`;
		},
		checkStar: function (value) {
			switch (value) {
				case "2":
					return "star2";
					break;
				case "3":
					return "star3";
					break;
				default:
					return;
			}
		},
		addInLottory: function (unit, key) {
			if (unit.active) {
				unit.up = false;
			}
			unit.active = !unit.active;
			this.$set(this.star3, key, unit);
		},
		addUp: function (unit, key) {
			var self = this;
			var star3 = self.star3;
			if (!unit.active) {
				return;
			}
			var activeList = _.filter(star3, function (o) {
				return o.active == true;
			});
			var upUnits = self.upList;
			var isUping = _.findKey(upUnits, function (o) {
				return o == unit.unit_id;
			});
			if (isUping) {
				upUnits.splice(isUping, 1);
			} else {
				if (upUnits.length >= 2) {
					upUnits.splice(0, 1);
				}
				upUnits.push(unit.unit_id);
			}

			self.upList = upUnits;

			var star3List = _.forEach(self.star3, function (o) {
				if (_.includes(upUnits, o.unit_id)) {
					o.up = true;
				} else {
					o.up = false;
				}
			});

			var hasUp = _.some(activeList, ["up", true]);
			var checkUpCount = _.filter(activeList, function (o) {
				return o.up == true;
			});
			var up2 = false;
			if (checkUpCount.length == 2) {
				up2 = true;
			}
			var nowPercent = Number(self.percent);
			var isUpUp = false;
			if (nowPercent == "5.5") {
				isUpUp = true;
				nowPercent = 5;
			}
			var odd = 0;
			var upPercent = 0.7;
			if (isUpUp) {
				upPercent = 1.4;
			}
			if (hasUp) {
				odd = ((nowPercent - upPercent) / (activeList.length - 1)).toFixed(4);
			} else {
				odd = (nowPercent / activeList.length).toFixed(4);
			}
			star3 = _.forEach(star3, function (o) {
				if (o.up) {
					if (up2) {
						o["odd"] = upPercent / 2;
					} else {
						o["odd"] = upPercent;
					}
				} else {
					o["odd"] = odd;
				}
			});
			this.star3 = star3;
		},
		open: function (value) {
			this.openHistory3star = !this.openHistory3star;
		},
		getCharaName: function (unit_id) {
			var unit = _.find(this.$store.getters.getUnitData, ["unit_id", unit_id]);
			if (unit) {
				return unit.unit_name;
			}
			return "";
		},
	},
	computed: {
		getStar3List: function () {
			var self = this;
			var star3 = this.star3;
			var activeList = _.filter(star3, function (o) {
				return o.active == true;
			});
			var checkUpCount = _.filter(star3, function (o) {
				return o.up == true;
			});
			var hasUp = _.some(activeList, ["up", true]);
			var odd = 0;
			var nowPercent = Number(self.percent);
			var isUpUp = false;
			if (nowPercent == "5.5") {
				isUpUp = true;
				nowPercent = 5;
			}
			var up2 = false;
			if (checkUpCount.length == 2) {
				up2 = true;
			}
			var upPercent = 0.7;
			if (isUpUp) {
				upPercent = 1.4;
			}
			if (hasUp) {
				odd = ((nowPercent - upPercent) / (activeList.length - 1)).toFixed(4);
			} else {
				odd = (nowPercent / activeList.length).toFixed(4);
			}
			star3 = _.forEach(star3, function (o) {
				if (o.up) {
					if (up2) {
						o["odd"] = upPercent / 2;
					} else {
						o["odd"] = upPercent;
					}
				} else {
					o["odd"] = odd;
				}
			});

			return star3;
		},
	},
	watch: {
		percent: function (val) {
			var self = this;
			if (val == "2.5") {
				self.kokoro = "我會為主人加油的";
				self.percent = "2.5";
			} else if (val == "5" || val == "5.5") {
				self.kokoro = "主人想試試看加倍的手氣嗎";
				setTimeout(function () {
					$(".upChance").fadeOut();
				}, 1500);
			} else {
				self.kokoro = "( ͡° ͜ʖ ͡ °)";
			}
		},
	},
	mounted: function () {
		(adsbygoogle = window.adsbygoogle || []).push({});
	},
};
</script>
<style rel="stylesheet/sass" lang="sass"></style>